/**
 * @file
 * bware_theme behaviors.
 */
(function (Drupal) {

  'use strict';

  Drupal.behaviors.bwareTheme = {
    attach: function (context, settings) {
      console.log('bware_theme.js');
      let toggle = document.getElementById('menu-toggle');
      if(!toggle.classList.contains('processed')) {
        toggle.addEventListener('click', function() {

          toggle.classList.toggle('open-icon');
          document.getElementById('body').classList.toggle('nav-open');

        });
        toggle.classList.add('processed');
        console.log(toggle);

      }

    }
  };

} (Drupal));
